import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferBusinessTypeVo } from './type';

/**
 * 当前卖家所有offer所涵盖的业务类型
  GET /product/offerManage/getBusinessByOffer
  接口ID：263628569
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628569
 */
export const getBusinessType = (): AxiosPromise<OfferBusinessTypeVo[]> => {
  return request({
    url: '/product/offerManage/getBusinessByOffer',
    method: 'get'
  });
};
